export default __webpack_public_path__ + "static/media/2.7778f27e.jpg";